import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import React from "react";
import { useTranslation } from "react-i18next";

interface ValidationAlertProps {
    numberOfInvalidShifts: number;
    minDurationHrs: number;
    maxDurationHrs: number;
}

const ValidationAlert: React.FC<ValidationAlertProps> = ({
	numberOfInvalidShifts,
	minDurationHrs,
	maxDurationHrs,
}) => {
	const { t } = useTranslation();
	return (
		<Alert severity='warning'>
			<AlertTitle>
				{t("scheduler_shifts-cannot-be-copied", {
					count: numberOfInvalidShifts,
				})}
			</AlertTitle>
			{t("scheduler_shift-duration-config-message", {
				min: minDurationHrs,
				max: maxDurationHrs,
			})}
		</Alert>
	);
};

export default ValidationAlert;
